import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { User } from "models";

export const useDeletePairedUsersMutation = () =>
  useTypedMutation<User, void>({
    mutationFn: async user => (await ApiInstance.post("/users/update", { ...user }, ENV.systemBaseURL)).data,
    onSuccess: updatedUser => {
      const prevUsers = typedQueryClient.getQueryData(UsersDashboardQueryKeys.users);
      if (!prevUsers) return;

      const { users } = prevUsers;
      const userIdx = users.findIndex(user => user.id === updatedUser.id);
      if (userIdx === -1) return;

      typedQueryClient.setQueryData(UsersDashboardQueryKeys.users, { ...prevUsers, users: users.with(userIdx, updatedUser) });
    }
  });
